import React from "react";
import { BodyCard, HeadCard, BottomCard, StyledPopup } from "./style";
import { RootState } from "../../redux/reducers/index";
import { useSelector } from "react-redux";
import { Card } from "../../theme/theme";
import { Close } from "../MainModal/Close";
import ModalButton from "../ModalButton";
import { CustomIcon } from "../CustomIcon";
import { language } from "../../utils/language";

const NotificationModal = (props: any) => {
	const homeState: HomeStateType = useSelector(
		(state: RootState) => state.home
	);
	return (
		<>
			<StyledPopup ref={props.refData} modal nested>
				{(close: any) => (
					<div>
						<Card className="container">
							<HeadCard {...props}>
								<CustomIcon color={""} hover={false} type="warning" width={props.width} height={props.height} />
								<Close
									onClick={() => { close(); props.onClose?.(); }}
									color={homeState.color}
									position={
										typeof props.positionAbsolute === "undefined" ||
										props.positionAbsolute
											? "absolute"
											: "initial"
									}
								>
									{" "}
								</Close>
							</HeadCard>
							<BodyCard {...props}>{props.message}</BodyCard>
							<BottomCard {...props}>
								<ModalButton
									color={homeState.color}
									secondary={false}
									onClick={() => { close(); props.onClose?.(); }}
								>
									{typeof props.textBtn === "undefined"
										? language[homeState.default_language]["ok"]
										: props.textBtn}
								</ModalButton>
							</BottomCard>
						</Card>
					</div>
				)}
			</StyledPopup>
		</>
	);
};

export default NotificationModal;
